var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-card",on:{"click":function($event){return _vm.goToNotificationTarget()}}},[_vm._v(" "+_vm._s(_vm.notification.description)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }